var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkyline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 43.8V128H79.8V43.8L96.1 20.8L112.3 43.8Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1 62.2001C53.0272 62.2001 55.4001 59.8272 55.4001 56.9001C55.4001 53.973 53.0272 51.6001 50.1 51.6001C47.1729 51.6001 44.8 53.973 44.8 56.9001C44.8 59.8272 47.1729 62.2001 50.1 62.2001Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1 98.8H36.6V105.29H40.1V98.8Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7 98.8H45.2V105.29H48.7V98.8Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1 110.4H36.6V116.89H40.1V110.4Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1 77.9H2.5V117.26H29.1V77.9Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.8 78.5H126.3V84.99H129.8V78.5Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.8 66.9H126.3V73.39H129.8V66.9Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M129.8 90.2001H126.3V96.6901H129.8V90.2001Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9 47.3001V39.2001",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3 66.5V74.6",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2 53.2001L33.5 50.6001",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59 60.6001L66.7 63.1001",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8 64.2001L39 70.7001",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4 49.6L61.2 43",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1 48.7001L40.4 42.1001",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1 65.1001L59.9 71.7001",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7 59.1001L33 61.6001",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 54.7001L67.2 52.2001",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6 47.6001H85.6V54.0901H88.6V47.6001Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5 67.4H88.5V60.91H85.5V67.4Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6 74.4H85.6V80.89H88.6V74.4Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M120.9 129.2V60.2001H147.5V129.2",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7 129.2V92.1001H83.8V123.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyline);
export default __webpack_public_path__ + "static/media/skyline.4eb05240c2d1ad8172883198f3352920.svg";
export { ForwardRef as ReactComponent };